import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWayForward = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 8,
	viewBox: "0 0 15 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.17 7.35L14.61 7.36L12.15 4.9L7.25 0L5.52 1.75L8.67 4.9H0V7.36H11.99V7.35H12.17Z",
		fill: "#3D5AFE"
	})]
});
const ForwardRef = forwardRef(SvgWayForward);
export { ForwardRef as ReactComponent };
